/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Radio } from '@material-ui/core';
import * as RegistrationConstants from './RegistrationConstants';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import { GetRegistrationOptionsActions, ValidateRegistrationOptionsActions } from '../Store/Actions/RegistrationActions';
import ErrorMessages from '../../../SharedModule/MessageHandlers/ErrorMessages';
import Spinner from '../../../SharedModule/Spinner/Spinner';
import moment from 'moment';
import RegistrationDialog from './RegistrationDialog';

export default function RecentVisits(props) {
    // Page Constants
    const dispatch = useDispatch();
    let errorMessagesArray = [];
    // eslint-disable-next-line no-unused-vars
    const [registrationValue, setRegistrationValue] = React.useState(
        props.location.state && props.location.state.registrationValue
            ? props.location.state.registrationValue
            : []
    );
    const [open, setOpen] = React.useState(false);
    const [disableSubmit, setDisableSubmit] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [selectedRecord, setSelectedRecord] = React.useState(null);
    const [spinnerLoader, setSpinnerLoader] = React.useState(false);
    const [registrationQuestions, setRegistrationQuestions] = React.useState([]);

    // Dispatch Actions
    const getRegistrationOptionsDispatch = (getRegistrationOptionsCriteria) => dispatch(GetRegistrationOptionsActions(getRegistrationOptionsCriteria));
    const validateRegistrationOptionsDispatch = (validateRegistrationOptionsCriteria) => dispatch(ValidateRegistrationOptionsActions(validateRegistrationOptionsCriteria));

    const registrationOptionsData = useSelector(state => state.registrationState.registrationOptions);
    const validateRegistrationOptionsData = useSelector(state => state.registrationState.validateRegistrationOptions);

    useEffect(() => {
        if (sessionStorage.getItem('disableClaimsOption')) {
            setDisableSubmit(true);
        }
        if (registrationValue && registrationValue.memberSystemId) {
            const registrationOptions = {
                memberSystemId: registrationValue.memberSystemId
            };
            setSpinnerLoader(true);
            getRegistrationOptionsDispatch(registrationOptions);
        }
    }, []);

    useEffect(() => {
        if (registrationOptionsData) {
            setSpinnerLoader(false);
            errorMessagesArray = [];
            setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(registrationOptionsData, errorMessagesArray, RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                setErrorMessages(errorMessagesArray);
            } else if (registrationOptionsData[0].id) {
                setRegistrationQuestions(registrationOptionsData);
            } else {
                errorMessagesArray.push(RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
                setErrorMessages(errorMessagesArray);
            }
        }
    }, [registrationOptionsData]);

    useEffect(() => {
        if (validateRegistrationOptionsData) {
            setSpinnerLoader(false);
            errorMessagesArray = [];
            setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(validateRegistrationOptionsData, errorMessagesArray, RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                // fix for page refresh
                if (errorMessagesArray[0].indexOf('selected option is incorrect') > -1) {
                    sessionStorage.setItem('disableClaimsOption', true);
                    setDisableSubmit(true);
                }
                setErrorMessages(errorMessagesArray);
            } else if (validateRegistrationOptionsData.id) {
                registrationValue.id = validateRegistrationOptionsData.id;
                setOpen(true);
            } else {
                errorMessagesArray.push(RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
                setErrorMessages(errorMessagesArray);
            }
        }
    }, [validateRegistrationOptionsData]);

    // Method to submit Registration Options Form
    const submitRegistrationOptionsForm = () => {
        errorMessagesArray = [];
        setErrorMessages([]);
        if (selectedRecord) {
            const validateRegistrationOptionsRequest = {
                userId: registrationValue.userID,
                firstName: registrationValue.firstName,
                lastName: registrationValue.lastName,
                email: registrationValue.emailAddress,
                phoneNumber: parseInt(registrationValue.phoneNumber),
                dob: moment(registrationValue.dob).format('YYYY-MM-DD'),
                ssn: registrationValue.memberSSN,
                mailingAddress: {
                    address: registrationValue.address,
                    city: registrationValue.city,
                    state: registrationValue.state !== AppConstants.SELECT ? registrationValue.state : '',
                    postalCode: registrationValue.postalCode
                },
                challengeResponses: [
                    { challenge: registrationValue.secQs1, response: registrationValue.answer1 },
                    { challenge: registrationValue.secQs2, response: registrationValue.answer2 },
                    { challenge: registrationValue.secQs3, response: registrationValue.answer3 }
                ],
                memberId: registrationValue.memberID,
                memberSystemId: registrationValue.memberSystemId,
                tcn: selectedRecord
            };
            setSpinnerLoader(true);
            validateRegistrationOptionsDispatch(validateRegistrationOptionsRequest);
        } else {
            errorMessagesArray.push(RegistrationConstants.NO_REGISTRATION_OPTION_ERROR);
            setErrorMessages(errorMessagesArray);
        }
    }

    return (
        <>
            {spinnerLoader ? <Spinner /> : null}
            <div className="registration-container">
                <div className="form-header-container col">
                    <div className="reg-heading">Member Registration</div>
                    <div className="secondary-form-heading">
                        <a className="text-white" href="/contactUs" target="_blank">Contact Us</a>
                        <span className="px-1">|</span>
                        <a className="text-white" href="/Help" target="_blank">Help</a>
                    </div>
                </div>

                <>
                {errorMessages && errorMessages.length > 0 ?
                    <div className="form-wrapper col-sm-12 px-3 mt-3">
                        <ErrorMessages errorMessages={errorMessages} />
                    </div> : null}
                    {registrationQuestions && registrationQuestions.length > 0 ?
                        <div className="container">
                            <div className="bg-white">
                                <form autoComplete="off">
                                    <div className="form-wrapper mt-3 col p-0">
                                        <div className='w-100 border-bottom-contactUs px-2'>
                                            <div className="sub-header">CHOOSE THE CORRECT VISIT IN THE PAST 6 MONTHS TO COMPLETE REGISTRATION</div>
                                        </div>
                                        <div className="col p-0 m-3">
                                            {registrationQuestions.map((registrationQuestion, index) => {
                                                return (<>
                                                    <div className="form-check form-check-inline py-2">
                                                        <Radio
                                                            disableRipple
                                                            id={index}
                                                            className="form-check-input"
                                                            value={registrationQuestion.id}
                                                            name="check"
                                                            checked={selectedRecord && selectedRecord !== '0' && selectedRecord === registrationQuestion.id}
                                                            onChange={() => {
                                                                setSelectedRecord(registrationQuestion.id)
                                                            }
                                                            }
                                                        />
                                                        <label className="form-check-label" htmlFor={index} >
                                                            {['Visit on ', <strong>{registrationQuestion.fdos ? moment.parseZone(registrationQuestion.fdos).format('DD MMM YYYY') : ''}</strong>, ' to ', <strong>{registrationQuestion.renderingProviderTypeDesc}</strong>, ' - ', <strong>{registrationQuestion.renderingProvider}</strong>, ' for ', <strong>{registrationQuestion.descOfService}</strong>, '.']}
                                                        </label>
                                                    </div><br />
                                                </>)
                                            })}
                                            {registrationQuestions && registrationQuestions.length < 6 ?
                                                <div className="form-check form-check-inline py-2">
                                                    <Radio
                                                        disableRipple
                                                        name="check"
                                                        className="form-check-input"
                                                        value="None of the above"
                                                        id="check-nota"
                                                        checked={selectedRecord === '0'}
                                                        onChange={() => {
                                                            setSelectedRecord('0')
                                                        }
                                                        }
                                                    />
                                                    <label className="form-check-label" htmlFor="check-nota">
                                                        None of the above
                                </label>
                                                </div> : null
                                            }

                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="clearfix"></div>
                            <div className="py-3">
                                <div className="row m-0 reg-footer">
                                    <span className="gray-font">Page 2 of 2</span>
                                </div>
                                <div className="row m-0">
                                    <Button className='btn-primary btn-xs ml-sm-0 mr-sm-3'
                                        disabled={disableSubmit} onClick={submitRegistrationOptionsForm}>
                                        Submit </Button>
                                    <Button className='btn-transparent btn-xs ml-sm-0' onClick={() => AppConstants.backToLogin(props)}>
                                        Cancel </Button>
                                </div>
                            </div>
                        </div> : null}
                </>
                {open ? <RegistrationDialog open={open} setOpen={setOpen} history={props.history}
                    registrationValue={registrationValue} /> : null}
            </div>
        </>
    )
}